import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillsContactFilterWrapper = styled.div`
  margin-left: ${Spacing.S8};
`
